// Desktop Settings Card Component
// Placeholder for desktop settings - coming soon

import React from 'react';
import './DesktopSettingsCard.css';

export function DesktopSettingsCard({ manager }) {
  return (
    <div className="desktop-settings-card">
      <div className="desktop-settings-header">
        <h3>Desktop Settings</h3>
        <p>Configure how Revolt Desktop behaves on your system</p>
      </div>

      <div className="desktop-settings-coming-soon">
        <div className="coming-soon-icon">
          <i className="fa-solid fa-tools"></i>
        </div>
        <h4>Coming Soon</h4>
        <p>Desktop-specific settings and configuration options will be available here.</p>
        <div className="coming-soon-features">
          <div className="feature-item">
            <i className="fa-solid fa-power-off"></i>
            <span>Startup behavior</span>
          </div>
          <div className="feature-item">
            <i className="fa-solid fa-window-minimize"></i>
            <span>Window management</span>
          </div>
          <div className="feature-item">
            <i className="fa-solid fa-brain"></i>
            <span>Local AI model settings</span>
          </div>
        </div>
      </div>
    </div>
  );
}
